import TaskStatesRequest from '../ws/TaskStatesRequest';
import TasksRequest from '../ws/TasksRequest';
import DocumentsRequest from '../../../../documents/ws/DocumentsRequest';
import DocumentSchemaType from '../../../../shared/model/DocumentSchemaType';
import TaskChangeStatesRequest from '../ws/TaskChangeStatesRequest';
import DocumentsTaskLinkRequest from '../ws/DocumentsTaskLinkRequest';
import Alert from 'react-s-alert';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { MONTHLY_WORK_CHECK_UPDATE } from '../../../monthly/actions/monthlyActions';
import TaskSendEmailRequest from '../ws/TaskSendEmailRequest';
import { WorkChecksRequest } from '../../../../shared/work-checks/work-checks-list/WorkChecksRequest';
import { WorkChecksTask } from '../../../../shared/work-checks/work-checks-list/WorkChecksTask';

export const TASK_STATES = 'task-states';

export const TASKS_LOADING = 'tasks-loading';
export const TASKS_UPDATE = 'tasks-update';
export const TASKS_UPDATE_TASK = 'tasks-update-task';
export const TASKS_UPDATE_STATE = 'tasks-update-state';
export const TASKS_DOCUMENTS_UPDATE = 'tasks-documents-update';
export const TASKS_ERROR = 'tasks-error';

export const TASKS_UPDATE_ACTIVE = 'tasks-update-active';

export const TASKS_WORK_CHECKS_MODAL = 'tasks-work-check-modal';
export const TASKS_UPDATE_MONTHLY_TASK = 'tasks-update-monthly-task';

export const TASKS_DOCUMENTS_MODAL = 'tasks-documents-model';
export const TASKS_ERROR_DOCUMENTS = 'tasks-error-documents';

export const getTasks = (page = 1, search = '', filter = 0, filterOptions = {}) => (dispatch) => {

    new TasksRequest(page, search, null, filter, filterOptions)
        .onPreExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: true });
        })
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: TASKS_UPDATE,
                payload: response,
            });
        })
        .onFail(error => {
            dispatch({ type: TASKS_ERROR, payload: error });
        })
        .onPostExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: false });
        })
        .execute();
};

export const getTaskTypes = () => (dispatch) => {
    new TaskStatesRequest()
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: TASK_STATES,
                payload: response,
            });
        })
        .execute();
};

export const changeTaskState = (task, taskStateId) => (dispatch) => {

    new TaskChangeStatesRequest(task.id, taskStateId)
        .onPreExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: true });
        })
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: TASKS_UPDATE_STATE,
                id: task.id,
                payload: response,
            });
            dispatch({ type: TASKS_UPDATE_ACTIVE, payload: task.id });
        })
        .onFail(error => {
            Alert.error(error);
        })
        .onPostExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: false });
        })
        .execute();
};

export const sendMailTask = (task) => (dispatch) => {

    new TaskSendEmailRequest(task.id)
        .onPreExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: true });
        })
        .onSuccess(response => {
            Alert.success(I18nUtils.tr('TR_EMAIL_ENVIADO_CORRECTAMENTE'));
            // Enviamos los datos a redux
            dispatch({
                type: TASKS_UPDATE_TASK,
                id: task.id,
                payload: { ...task, email_sent_date: new Date() },
            });
            dispatch({ type: TASKS_UPDATE_ACTIVE, payload: task.id });
        })
        .onFail(error => {
            Alert.error(error);
        })
        .onPostExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: false });
        })
        .execute();
};

/* WORK CHECKS */

export const getWorkChecks = (task) => (dispatch) => {

    const request = new WorkChecksRequest();
    request.setConstructionId(task.construction.id);
    request.setYear(task.year);
    request.setMonth(task.month);
    request.setCompanyId(task.company_child.id);
    request.setIncludeDocuments(true);

    new WorkChecksTask(request)
        .onPreExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: true });
        })
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: MONTHLY_WORK_CHECK_UPDATE,
                payload: response,
            });
            // Abrimos modal de WorkChecks
            dispatch({ type: TASKS_UPDATE_MONTHLY_TASK, payload: task });
            dispatch({
                type: TASKS_WORK_CHECKS_MODAL,
                payload: true,
                title: task.company_child.name,
                subtitle: I18nUtils.tr('TR_TRABAJADORES'),
                date: `${task.month}/${task.year}`,
                build: task.construction.code,
            });
            dispatch({ type: TASKS_UPDATE_ACTIVE, payload: task.id });
        })
        .onFail(error => {
            Alert.error(error);
        })
        .onPostExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: false });
        })
        .execute();
};

export const updateWorkChecks = (task) => (dispatch) => {

    const request = new WorkChecksRequest();
    request.setConstructionId(task.construction.id);
    request.setYear(task.year);
    request.setMonth(task.month);
    request.setCompanyId(task.company_child.id);
    request.setIncludeDocuments(true);

    new WorkChecksTask(request)
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: MONTHLY_WORK_CHECK_UPDATE,
                payload: response,
            });
        })
        .execute();
};

export const hideWorkCheckDialog = () => ( {
    type: TASKS_WORK_CHECKS_MODAL,
    payload: false,
} );

/* DOCUMENTS */

export const hideDocumentsDialog = () => ( {
    type: TASKS_DOCUMENTS_MODAL,
    payload: false,
} );

export const getDocumentsMonthly = (task) => (dispatch) => {
    new DocumentsRequest(
        0,
        null,
        0,
        DocumentSchemaType.MONTHLY,
        {
            company_id: task.company_child.id,
            construction_id: task.construction.id,
        },
        null,
        true,
        task.month,
        task.year,
        true,
    )
        .onPreExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: true });
        })
        .onSuccess(response => {
            // Obtenemos los documentos vinculados con check de mensual.
            new DocumentsRequest(
                0,
                null,
                0,
                DocumentSchemaType.LINKED,
                {
                    company_id: task.company_child.id,
                    construction_id: task.construction.id,
                },
                null,
                true,
                task.month,
                task.year,
                true,
                null,
                true,
            )
                .onPreExecution(() => {
                    dispatch({ type: TASKS_LOADING, payload: true });
                })

                .onSuccess(responseLinked => {
                    var data = {data: [...response.data, ...responseLinked.data]}
                    dispatch({
                        type: TASKS_DOCUMENTS_UPDATE,
                        payload: data,
                    });
                    // Abrimos modal de documentos
                    dispatch({
                        type: TASKS_DOCUMENTS_MODAL,
                        payload: true,
                        title: task.company_child.name,
                        subtitle: I18nUtils.tr('TR_DOCUMENTOS_MENSUALES'),
                        date: `${task.month}/${task.year}`,
                        build: task.construction.code,
                    });
                    dispatch({
                        type: TASKS_DOCUMENTS_MODAL,
                        payload: true,
                        title: task.company_child.name,
                        subtitle: I18nUtils.tr('TR_DOCUMENTOS_MENSUALES'),
                        date: `${task.month}/${task.year}`,
                        build: task.construction.code,
                    });
                    dispatch({ type: TASKS_UPDATE_ACTIVE, payload: task.id });
                })
                .onFail(error => {
                    Alert.error(error);
                })
                .onPostExecution(() => {
                    dispatch({ type: TASKS_LOADING, payload: false });
                })
                .execute();
        })
        .onFail(error => {
            Alert.error(error);
        })
        .onPostExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: false });
        })
        .execute();
};

export const getDocumentsLinked = (task) => (dispatch) => {

    new DocumentsTaskLinkRequest(task.company_parent.id, task.company_child.id, task.construction.id, task.month, task.year)
        .onPreExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: true });
        })
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: TASKS_DOCUMENTS_UPDATE,
                payload: response,
            });
            // Abrimos modal de documentos
            dispatch({
                type: TASKS_DOCUMENTS_MODAL,
                payload: true,
                title: task.company_child.name,
                subtitle: I18nUtils.tr('TR_DOCUMENTOS_VINCULADOS'),
                date: `${task.month}/${task.year}`,
                build: task.construction.code,
            });
            dispatch({ type: TASKS_UPDATE_ACTIVE, payload: task.id });
        })
        .onFail(error => {
            Alert.error(error);
        })
        .onPostExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: false });
        })
        .execute();
};

export const getDocumentsCompany = (task) => (dispatch) => {

    new DocumentsRequest(
        0,
        null,
        0,
        DocumentSchemaType.OUTSOURCE,
        { company_id: task.company_child.id },
        null,
        true,
        null,
        null,
        true,
    )
        .onPreExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: true });
        })
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: TASKS_DOCUMENTS_UPDATE,
                payload: response,
            });
            // Abrimos modal de documentos
            dispatch({
                type: TASKS_DOCUMENTS_MODAL,
                payload: true,
                title: task.company_child.name,
                subtitle: I18nUtils.tr('TR_DOCUMENTOS_SUBCONTRATA'),
                date: `${task.month}/${task.year}`,
                build: task.construction.code,
            });
            dispatch({ type: TASKS_UPDATE_ACTIVE, payload: task.id });
        })
        .onFail(error => {
            Alert.error(error);
        })
        .onPostExecution(() => {
            dispatch({ type: TASKS_LOADING, payload: false });
        })
        .execute();
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/actions/tasksActions.js